import dayjs from "dayjs";

const PREFIX = "ice_booking_draft";

// Uploaded files cannot be restored into the upload box, so they are never saved.
const UNSAVED_KEYS = new Set(["as_passport_photocopy", "passport_photocopy"]);

export type BookingDraftLayout = "desktop" | "v3";

const draftKey = (layout: BookingDraftLayout, itineraryId: string | number) => `${PREFIX}:${layout}:${itineraryId}`;

const serialize = (draft: unknown) =>
  JSON.stringify(draft, function (this: any, key: string, value: any) {
    if (UNSAVED_KEYS.has(key)) return undefined;
    return dayjs.isDayjs(this[key]) ? { __dayjs: this[key].toISOString() } : value;
  });

const revive = (_key: string, value: any) =>
  value && typeof value === "object" && "__dayjs" in value ? dayjs(value.__dayjs) : value;

export const saveBookingDraft = (layout: BookingDraftLayout, itineraryId: string | number, draft: unknown) => {
  try {
    sessionStorage.setItem(draftKey(layout, itineraryId), serialize(draft));
  } catch (_error) {
    // Storage can be full or blocked; the form still works, it just won't be remembered.
  }
};

export const loadBookingDraft = <T,>(layout: BookingDraftLayout, itineraryId: string | number): T | null => {
  try {
    const stored = sessionStorage.getItem(draftKey(layout, itineraryId));
    return stored ? (JSON.parse(stored, revive) as T) : null;
  } catch (_error) {
    return null;
  }
};

export const clearBookingDrafts = () => {
  try {
    Object.keys(sessionStorage)
      .filter(key => key.startsWith(`${PREFIX}:`))
      .forEach(key => sessionStorage.removeItem(key));
  } catch (_error) {
    // Nothing to clear when storage is unavailable.
  }
};
